import { ElementStatus, RuleListStatus } from '@wix/rules-panel-ui';
import { assertNever } from '@wix/seo-common-core';
export const convertBooleanStatusToElementStatus = status => status ? ElementStatus.Passed : ElementStatus.Failed;

// TODO: move to a shared location (rules-panel-ui or a11y-wizard public API) — used across multiple repos
export const convertScanStatusToUiStatus = status => {
  switch (status) {
    case 'passed':
    case 'not-applicable':
      return RuleListStatus.passed;
    case 'error':
    case 'failed':
      return RuleListStatus.failed;
    default:
      assertNever(status);
  }
};
export const convertUiStatusToBoolean = status => {
  switch (status) {
    case RuleListStatus.passed:
    case RuleListStatus.recommendation:
      return true;
    case RuleListStatus.failed:
    case RuleListStatus.error:
    case RuleListStatus.disabled:
    case RuleListStatus.pending:
    case RuleListStatus.loading:
      return false;
  }
};
//# sourceMappingURL=convert-status-type.js.map